export const mainColor = "#820F4C";
export const pd = "15px";
export const white = "#fff";
export const black = "#000";
export const secondaryColor = "#929292";
export const gray = "#f9f9f9";
export const beige = "#EDEDED";
export const backgroundRowTable = "#F4F4F4";
export const Black = '#000';
export const Red = '#F02424';
export const Yellow = '#EBBF2B';
export const Green = '#418D18';
export const White = '#FFFFFF';
export const Orange = '#CB830E';
export const Blue = '#355FD3';
export const Grey = "#D3D3D3"

export const NOIRFUSION = {
  color1: "#000000",
  color2: "#252524",
  color3: "#383737",
  color4: "#BC3D81",
  color5: "#820F4C",
  colorChooseItem: "#383737",
  colorText: "#FFFFFF",
  backGroundParticular: "#383737",
  footerParticular: "#000000",
  backgroundActiveTooltip: "#F7EAF1",
  textColorActiveTooltip: "#000000",
  colorButton:
    "transparent linear-gradient(360deg, #820f4c 0%, #bc3d81 100%) 0% 0% no-repeat padding-box",
};

export const PUREELEGANCE = {
  color1: "#F9F9F9",
  color2: "#FFFFFF",
  color3: "#000000",
  color4: "#BC3D81",
  color5: "#820F4C",
  colorChooseItem: "#EFEFEF",
  colorText: "#000000",
  backGroundParticular: "#F9F9F9",
  footerParticular: "#000000",
  backgroundActiveTooltip: "#F7EAF1",
  textColorActiveTooltip: "#000000",
  colorButton:
    "transparent linear-gradient(360deg, #820f4c 0%, #bc3d81 100%) 0% 0% no-repeat padding-box",
};

export const CHARCOALCHIC = {
  color1: "#636C78",
  color2: "#E3E3E3",
  color3: "#000000",
  color4: "#BC3D81",
  color5: "#820F4C",
  colorChooseItem: "#636C78",
  colorText: "#000000",
  backGroundParticular: "#636C78",
  footerParticular: "#E3E3E3",
  backgroundActiveTooltip: "#F7EAF1",
  textColorActiveTooltip: "#000000",
  colorButton:
    "transparent linear-gradient(360deg, #820f4c 0%, #bc3d81 100%) 0% 0% no-repeat padding-box",
};

export const REGALBLAZE = {
  color1: "#14213D",
  color2: "#273B67",
  color3: "#7B86A1",
  color4: "#FCA311",
  color5: "#C7810E",
  colorChooseItem: "#7B86A1",
  colorText: "#FFFFFF",
  backGroundParticular: "#14213D",
  footerParticular: "#273B67",
  backgroundActiveTooltip: "#F9F1E5",
  textColorActiveTooltip: "#14213D",
  // colorButton: "#C7810E",
  colorButton:
    "transparent linear-gradient(360deg, #C7810E 0%, #FCA311 100%) 0% 0% no-repeat padding-box",
};

export const chooseThemeColor: any = {
  NOIRFUSION,
  PUREELEGANCE,
  CHARCOALCHIC,
  REGALBLAZE,
};

export const mainFontSize = "2rem";
export const responsiveFontSize = "1.6rem";
export const customTransition = "all 0.3s ease";

export type Theme = 'NOIRFUSION' | 'PUREELEGANCE' | 'CHARCOALCHIC' | 'REGALBLAZE' | undefined; 